import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "trigger-icon-wrap" }
const _hoisted_3 = {
  key: 0,
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_5 = {
  key: 0,
  class: "trigger-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarLogo = _resolveComponent("SidebarLogo")!
  const _component_SidebarItem = _resolveComponent("SidebarItem")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'has-logo': _ctx.showLogo, 'is-collapsed': _ctx.isCollapse }, "sideWrap"])
  }, [
    (_ctx.showLogo)
      ? (_openBlock(), _createBlock(_component_SidebarLogo, {
          key: 0,
          collapse: _ctx.isCollapse
        }, null, 8, ["collapse"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_scrollbar, {
      "wrap-class": "scrollbar-wrapper",
      class: "sidebar-scrollbar"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          collapse: _ctx.isCollapse,
          "unique-opened": false,
          "default-active": _ctx.activeMenu,
          mode: "vertical",
          router: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
              return (_openBlock(), _createBlock(_component_SidebarItem, {
                key: route.path,
                item: route,
                "base-path": route.path,
                "is-collapse": _ctx.isCollapse
              }, null, 8, ["item", "base-path", "is-collapse"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["collapse", "default-active"])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      id: "sidebar-collapse-trigger",
      class: "sidebar-collapse-trigger",
      title: _ctx.isCollapse ? '展开菜单' : '收起菜单',
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSideBar && _ctx.toggleSideBar(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isCollapse)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                ry: "2"
              }, null, -1),
              _createElementVNode("line", {
                x1: "9",
                y1: "3",
                x2: "9",
                y2: "21"
              }, null, -1),
              _createElementVNode("path", { d: "m14 9-3 3 3 3" }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                ry: "2"
              }, null, -1),
              _createElementVNode("line", {
                x1: "9",
                y1: "3",
                x2: "9",
                y2: "21"
              }, null, -1),
              _createElementVNode("path", { d: "m13 15 3-3-3-3" }, null, -1)
            ]))]))
      ]),
      (!_ctx.isCollapse)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "收起菜单"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1)
  ], 2))
}